import React from 'react';
import LocationSearchTrigger from 'modules/homescreen/components/LocationSearchTrigger';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import { Translator } from 'Translator';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface NavbarSearchTriggerProps {
  country: string;
  city?: string;
}

function NavbarSearchTrigger({ city, country, history }: NavbarSearchTriggerProps & RouteComponentProps) {
  const onSearchClick = () => {
    history.push({
      pathname: generatePathnameWithLangCode('/filter/location/', Translator.getLanguageCode()),
      state: { modal: true, navbar: true },
    });
  };

  const onSearchClose = () => {
    history.push({
      pathname: generatePathnameWithLangCode('/filter/location/', Translator.getLanguageCode()),
      state: { modal: true, navbar: true },
    });
  };

  return (
    <LocationSearchTrigger
      selectedCity={city}
      selectedCountry={country}
      onClick={onSearchClick}
      onClose={onSearchClose}
    />
  );
}

export default withRouter(NavbarSearchTrigger);
